import "./Layout.scss";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { CiMenuBurger } from "react-icons/ci";
import UserProfile from "./UserProfile";
import { ImCross } from "react-icons/im";
import { FaCircleUser } from "react-icons/fa6";
// import { SiHiveBlockchain } from "react-icons/si";
import {
  MdDashboard,
  // MdTour
} from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { INSERT_ACCESS } from "../../_contstants/common";
// import { LuBookPlus } from "react-icons/lu";
// import { GiCommercialAirplane, GiTicket } from "react-icons/gi";
// import { RiHotelLine } from "react-icons/ri";
// import { LiaCalendarDaySolid } from "react-icons/lia";
// import { GrTransaction } from "react-icons/gr";
// import { TbReportSearch, TbWorldWww } from "react-icons/tb";
import { TbReceiptRupee } from "react-icons/tb";
import { LiaInfoSolid } from "react-icons/lia";
import { FaMeta } from "react-icons/fa6";
import { IoMdPersonAdd } from "react-icons/io";
import IconComponent from "../common/IconComponent";
import { FaUser } from "react-icons/fa";

const menuData = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <IconComponent icon={MdDashboard} />,
    quickMenu: [],
    sections: [],
  },

  {
    key: "contact",
    title: "Contact",
    icon: <IconComponent icon={FaUser} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "lead",
    title: "Lead",
    icon: <IconComponent icon={IoMdPersonAdd} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "inquiry",
    title: "Inquiry",
    icon: <IconComponent icon={LiaInfoSolid} />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "quotation",
    title: "Quotation",
    icon: (
      <IconComponent icon={TbReceiptRupee} style={{ fill: "transparent" }} />
    ),
    quickMenu: [],
    sections: [],
  },
  // {
  //   key: "tourbooking",
  //   title: "Booking Form",
  //   icon: <IconComponent icon={LuBookPlus} style={{ fill: "transparent" }} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  {
    key: "usermanagement",
    title: "User Management",
    icon: <IconComponent icon={FaCircleUser} />,
    quickMenu: [
      // { title: "Menu", key: "menu" },
      // { title: "Rights", key: "rights" },
      { title: "User", key: "user" },
      { title: "User Type", key: "usertype" },
    ],
    sections: [],
  },
  // {
  //   key: "masters",
  //   title: "Masters",
  //   icon: <IconComponent icon={SiHiveBlockchain} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Place",
  //       children: [
  //         {
  //           title: "Country",
  //           key: "country",
  //         },
  //         {
  //           title: "State",
  //           key: "state",
  //         },
  //         {
  //           title: "City",
  //           key: "city",
  //         },
  //         {
  //           title: "Region",
  //           key: "region",
  //         },
  //         {
  //           title: "Sector",
  //           key: "sector",
  //         },
  //         {
  //           title: "Flight Place",
  //           key: "flightplace",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Flight",
  //       children: [
  //         {
  //           title: "Airline",
  //           key: "airline",
  //         },
  //         {
  //           title: "Airline Class",
  //           key: "airlineclass",
  //         },
  //         {
  //           title: "Airport",
  //           key: "airport",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Generals",
  //       children: [
  //         {
  //           title: "Company",
  //           key: "company",
  //         },
  //         {
  //           title: "GST",
  //           key: "gst",
  //         },
  //         {
  //           title: "Nationality",
  //           key: "nationality",
  //         },
  //         {
  //           title: "Speciality Type",
  //           key: "specialitytype",
  //         },
  //         {
  //           title: "Room Type",
  //           key: "roomtype",
  //         },
  //         {
  //           title: "Meal Type",
  //           key: "mealtype",
  //         },
  //         {
  //           title: "Vendor",
  //           key: "vendor",
  //         },
  //         {
  //           title: "Vendor Type",
  //           key: "vendortype",
  //         },
  //         {
  //           title: "Currency",
  //           key: "currency",
  //         },
  //         {
  //           title: "Vehicle Sharing Pax",
  //           key: "vehiclesharingpax",
  //         },
  //         {
  //           title: "Pax Type",
  //           key: "paxtype",
  //         },
  //         {
  //           title: "Route",
  //           key: "route",
  //         },
  //         {
  //           title: "Branch",
  //           key: "branch",
  //         },
  //         {
  //           title: "Food Option",
  //           key: "foodoption",
  //         },
  //         {
  //           title: "Room Category",
  //           key: "roomcategory",
  //         },
  //         {
  //           title: "Hotel Mapping",
  //           key: "hotelmapping",
  //         },
  //         {
  //           title: "Vehicle Type",
  //           key: "vehicletype",
  //         },
  //         {
  //           title: "Vehicle",
  //           key: "vehicle",
  //         },
  //         {
  //           title: "Lead Source",
  //           key: "leadsource",
  //         },
  //         {
  //           title: "Festivals",
  //           key: "festivals",
  //         },
  //         {
  //           title: "Cancellation Policy",
  //           key: "cancellationpolicy",
  //         },
  //         {
  //           title: "Itinerary",
  //           key: "itinerary",
  //         },
  //         {
  //           title: "Itinerary Facility",
  //           key: "itineraryfacility",
  //         },
  //         {
  //           title: "Agent",
  //           key: "agent",
  //         },
  //         {
  //           title: "Terms & Conditions",
  //           key: "termandcondition",
  //         },
  //         {
  //           title: "Lead Stage",
  //           key: "leadstage",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   key: "tour",
  //   title: "Add Tour",
  //   icon: <IconComponent icon={MdTour} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // {
  //   key: "hotel",
  //   title: "Hotel Details",
  //   icon: <IconComponent icon={RiHotelLine} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // {
  //   key: "grouproute",
  //   title: "Day Wise Itinerary",
  //   icon: <IconComponent icon={LiaCalendarDaySolid} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // {
  //   key: "block",
  //   title: "Block",
  //   icon: <IconComponent icon={SiHiveBlockchain} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Transctions",
  //       children: [
  //         {
  //           title: "Airline Block",
  //           key: "airlineblock",
  //         },
  //         {
  //           title: "Hotel Block",
  //           key: "hotelblock",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   key: "airlinevoucher",
  //   title: "Airline Ticket",
  //   icon: <IconComponent icon={GiCommercialAirplane} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // {
  //   key: "paymentreceipt",
  //   title: "Payment Receipt",
  //   icon: <IconComponent icon={GrTransaction} />,
  //   quickMenu: [],
  //   sections: [],
  // },
  // {
  //   key: "voucher",
  //   title: "Voucher",
  //   icon: <IconComponent icon={GiTicket} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Transctions",
  //       children: [
  //         {
  //           title: "Hotel Voucher",
  //           key: "hotelvoucher",
  //         },
  //         {
  //           title: "Route Voucher",
  //           key: "routevoucher",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   key: "reports",
  //   title: "Reports",
  //   icon: (
  //     <IconComponent icon={TbReportSearch} style={{ fill: "transparent" }} />
  //   ),
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "General",
  //       children: [
  //         {
  //           title: "Company Wise Booking Report",
  //           key: "companywisebookingreportform",
  //         },
  //         {
  //           title: "User Wise Tour Booking Report",
  //           key: "userwisetourbookingreportform",
  //         },
  //         {
  //           title: "Hotel Block Room Status",
  //           key: "hotelblockroomstatusform",
  //         },
  //         {
  //           title: "Customer Report",
  //           key: "customerreportform",
  //         },
  //         {
  //           title: "Tour Report",
  //           key: "tourreportform",
  //         },
  //         {
  //           title: "Tour Booking Invoice",
  //           key: "tourbookinginvoiceform",
  //         },
  //         {
  //           title: "Airline Excel",
  //           key: "airlineblockview",
  //         },
  //         {
  //           title: "Ledger Report",
  //           key: "ledgerreportform",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    key: "integrations",
    title: "Integrations",
    icon: <IconComponent icon={FaMeta} />,
    quickMenu: [],
    sections: [],
  },
  // {
  //   key: "webintegrations",
  //   title: "Web Integrations",
  //   icon: <IconComponent icon={TbWorldWww} />,
  //   quickMenu: [],
  //   sections: [
  //     {
  //       title: "Website",
  //       children: [
  //         {
  //           title: "Testimonial",
  //           key: "testimonial",
  //         },
  //         {
  //           title: "Seo Tag",
  //           key: "seotag",
  //         },
  //         {
  //           title: "Banner",
  //           key: "banner",
  //         },
  //         {
  //           title: "CMS",
  //           key: "cms",
  //         },
  //         {
  //           title: "FAQ",
  //           key: "faq",
  //         },
  //         {
  //           title: "Useful Links",
  //           key: "usefullinks",
  //         },
  //         {
  //           title: "Setting",
  //           key: "setting",
  //         },
  //         {
  //           title: "Blog",
  //           key: "blog",
  //         },
  //         {
  //           title: "Service",
  //           key: "service",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const MENUNAME = [
  "dashboard",
  "contact",
  "lead",
  "inquiry",
  "quotation",
  "tourbooking",
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const filterMenuByUserRights = (menuData: any, userRights: any) => {
    const hasRight = (key: string) => {
      if (key.includes("/create")) {
        const baseKey = key.replace("/create", "");
        const userMenu = userRights?.find(
          (menu: any) => menu.MenuKey === baseKey
        );
        return (
          userMenu && userMenu.RightsID.split(", ").includes(INSERT_ACCESS)
        );
      } else {
        return userRights?.some((menu: any) => menu.MenuKey === key);
      }
    };

    return menuData
      .map((menu: any) => {
        const mainMenuHasRight = hasRight(menu.key);

        if (!mainMenuHasRight) return null;

        const filteredQuickMenu = menu.quickMenu.filter((item: any) =>
          hasRight(item.key)
        );
        const filteredSections = menu.sections
          .map((section: any) => {
            const filteredChildren = section.children.filter((child: any) =>
              hasRight(child.key)
            );
            return { ...section, children: filteredChildren };
          })
          .filter((section: any) => section.children.length > 0);
        if (
          hasRight(menu.key) ||
          filteredQuickMenu.length > 0 ||
          filteredSections.length > 0
        ) {
          return {
            ...menu,
            quickMenu: filteredQuickMenu,
            sections: filteredSections,
          };
        }
        return null;
      })
      .filter((menu: any) => menu !== null);
  };

  const filteredMenus = filterMenuByUserRights(menuData, userRights);

  const toggleMenu = () => {
    document.querySelectorAll(".navbar-nav > li").forEach((element) => {
      element.addEventListener("click", function (this: HTMLElement) {
        document.querySelector(".page-contect")?.classList.remove("in");
        document.querySelectorAll(".navbar-nav > li").forEach((li) => {
          li.classList.remove("active");
          const popup = document.querySelector(
            ".navbar-nav > li.active .subnav-content"
          );
          if (popup) {
            const popupElement = popup as HTMLElement;
            popupElement.classList.remove("d-block");
            popupElement.classList.add("d-none");
          }
        });
        this.classList.add("active");
        const popup = document.querySelector(
          ".navbar-nav > li.active .subnav-content"
        );
        if (popup) {
          const popupElement = popup as HTMLElement;
          popupElement.classList.remove("d-none");
          popupElement.classList.add("d-block");
        }
      });
    });
  };

  useEffect(() => {
    toggleMenu();
  }, []);

  const toggleSubMenu = () => {
    const popup = document.querySelector(
      ".navbar-nav > li.active .subnav-content"
    );
    if (popup) {
      const popupElement = popup as HTMLElement;
      popupElement.classList.remove("d-block");
      popupElement.classList.add("d-none");
    }

    document.querySelectorAll(".navbar-nav > li").forEach((li) => {
      li.classList.remove("active");
    });
  };

  const toggleNav = () => {
    const sidenav = document.querySelector(".side-nav") as any;
    const mbottom = document.querySelector(".m-bottom") as any;
    const ainavbarheader = document.querySelector(".ainavbar-header") as any;
    const pagewrapper =
      document.querySelector(".page-wrapper") ||
      (document.querySelector(".dashboard-page-wrapper") as any);
    const pagecontect = document.querySelectorAll(".page-contect") as any;
    const menuName = document.querySelectorAll(".menu-name") as any;
    const greaterThan = document.querySelector(".greaterthan") as any;
    const lessThan = document.querySelector(".lessthan") as any;
    // const headerTitle = document.querySelector(".header-title") as any;

    const isOpen = sidenav.style.width === "210px";
    const isHeaderOpen = ainavbarheader.style.width === "210px";
    // headerTitle.style.setProperty("--content", isOpen ? '"AI"' : '"AICRM"');
    sidenav.style.width = isOpen ? "60px" : "210px";
    mbottom.style.width = isOpen ? "60px" : "210px";
    pagewrapper.style.marginLeft = isOpen ? "60px" : "210px";
    ainavbarheader.style.width = isHeaderOpen ? "60px" : "210px";
    pagecontect.forEach((element: any) => {
      if (isOpen) {
        element.style.left = "60px";
      } else {
        element.style.left = "210px";
      }
    });
    menuName.forEach((element: any) => {
      if (isOpen) {
        element.style.transition = "0.5s";
        element.classList.remove("d-inline");
        element.classList.add("d-none");
      } else {
        element.style.transition = "0.5s";
        element.classList.remove("d-none");
        element.classList.add("d-inline");
      }
    });
    if (isOpen) {
      lessThan.classList.remove("d-block");
      lessThan.classList.add("d-none");
      greaterThan.classList.remove("d-none");
      greaterThan.classList.add("d-block");
    } else {
      lessThan.classList.remove("d-none");
      lessThan.classList.add("d-block");
      greaterThan.classList.remove("d-block");
      greaterThan.classList.add("d-none");
    }
  };

  const handleNavigate = (url: string) => {
    if (url) {
      toggleSubMenu();
      navigate(`${url}`);
    }
  };

  return (
    <>
      <div id="wrapper">
        <nav className="ainavbar" role="navigation">
          <div className="ainavbar-header" style={{ width: 210 }}>
            <button type="button" className="navbar-toggle">
              <IconComponent icon={CiMenuBurger} />
            </button>
            <h3 className="m-0 header-title">AMT</h3>
          </div>
          <div className="d-flex align-items-center">
            <UserProfile />
          </div>
        </nav>
        <div className="collapse navbar-collapse navbar-ex1-collapse show">
          <ul
            className="nav navbar-nav side-nav"
            style={{ zIndex: 10, scrollbarWidth: "none", width: 210 }}
          >
            {filteredMenus.map((menu: any, index: any) => {
              const lastKey = MENUNAME?.slice()
                ?.reverse()
                ?.find((key: any) =>
                  filteredMenus.some((m: any) => m?.key === key)
                );
              return (
                <li
                  className="subnav"
                  key={index}
                  onClick={toggleMenu}
                  style={{
                    marginBottom: filteredMenus?.length - 1 === index ? 55 : 0,
                    borderBottom:
                      menu.key === lastKey ? "1px solid lightgray" : "none",
                  }}
                >
                  <p
                    className="collapsed"
                    onClick={() =>
                      menu.key === "dashboard"
                        ? navigate("/")
                        : menu.quickMenu?.length < 1 &&
                          menu.sections?.length < 1
                        ? navigate(`/${menu?.key}`)
                        : null
                    }
                  >
                    <Tooltip
                      anchorElement="target"
                      position="right"
                      parentTitle={true}
                    >
                      <span title={menu.title} className="m-0">
                        {menu.icon}
                        <span className="menu-name">{menu.title || ""}</span>
                      </span>
                    </Tooltip>
                  </p>
                  {(menu.quickMenu?.length > 0 ||
                    menu.sections?.length > 0) && (
                    <div className="subnav-content page-contect">
                      <div className="container-fluid">
                        <div className="container-title">
                          <h2 className="fw-600">{menu.title} - Quick Menu</h2>
                          <button
                            className="model-close"
                            onClick={toggleSubMenu}
                          >
                            <IconComponent icon={ImCross} />
                          </button>
                        </div>
                        {menu.quickMenu?.length > 0 && (
                          <div className="quick-menu">
                            <div className="quick-menu-cards">
                              {menu.quickMenu.map((item: any) => (
                                <div
                                  key={item.key}
                                  className="quick-menu-card"
                                  onClick={() => handleNavigate(item.key)}
                                >
                                  <h5>{item.title}</h5>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        <div className="section-list">
                          {menu.sections?.map(
                            (section: any) =>
                              section.children?.length > 0 && (
                                <div key={section.title} className="section">
                                  <h4>{section.title}</h4>
                                  <ul>
                                    {section.children.map((child: any) => (
                                      <Tooltip
                                        key={child.key}
                                        anchorElement="target"
                                        position="top"
                                        parentTitle={true}
                                      >
                                        <li
                                          key={child.key}
                                          title={child.title}
                                          onClick={() =>
                                            handleNavigate(child.key)
                                          }
                                        >
                                          {child.title}
                                        </li>
                                      </Tooltip>
                                    ))}
                                  </ul>
                                </div>
                              )
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
            <div className="m-bottom" onClick={toggleNav}>
              <span className="m-arrow">
                <IconComponent
                  icon={FaGreaterThan}
                  className="greaterthan d-none cursor-pointer"
                />
                <IconComponent
                  icon={FaLessThan}
                  className="lessthan cursor-pointer"
                />
              </span>
            </div>
          </ul>
        </div>
        {location.pathname === "/" ? (
          <div className="all-page">
            <div className="dashboard-page-wrapper">
              <Outlet />
            </div>
          </div>
        ) : (
          <div className="all-page">
            <div className="page-wrapper">
              <div className="page-information ">
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Layout;
